import { useHotkeys } from "@blueprintjs/core"
import { useMemo } from "react"

/**
 * Глобальный Esc — отмена редактирования.
 *
 * Заменяет декоратор `@HotkeysTarget` с методом `renderHotkeys`, которого нет
 * в Blueprint начиная с 4-й версии (в 5-й он ещё лежит в legacy, но помечен
 * устаревшим и уйдёт в 6-й). Компонент ничего не рисует: сочетание глобальное,
 * обработчик вешается на document, разметка ему не нужна — поэтому его можно
 * ставить и внутрь таблиц, где лишний div сломал бы вёрстку.
 */
export const GlobalEscape = ({ onEscape, label = "отменить редактирование" }: GlobalEscapeProps) => {
    const hotkeys = useMemo(
        () => [
            {
                combo: "esc",
                global: true,
                allowInInput: true,
                label,
                onKeyUp: onEscape,
            },
        ],
        [label, onEscape]
    )

    useHotkeys(hotkeys)

    return null
}

interface GlobalEscapeProps {
    onEscape: () => void
    /** подпись в справке по горячим клавишам */
    label?: string
}
